import { render, staticRenderFns } from "./menuManagement.vue?vue&type=template&id=8cfc4a88&"
import script from "./menuManagement.vue?vue&type=script&lang=js&"
export * from "./menuManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports